module.exports = __webpack_public_path__ + "img/typeother.4b5f38c9.png";